export default "__VITE_ASSET__ccdcbd27__"